import { IS_NATIVE_APP } from "../config/appTarget.js";

/**
 * Opens an external http(s) URL in the correct browser context.
 *
 * On iOS (Capacitor): uses `@capacitor/browser` (SFSafariViewController) so
 * the URL opens in Safari — NOT inside WKWebView which Apple prohibits for
 * user-facing external content.
 *
 * On web: opens in a new tab with `noopener,noreferrer`.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (IS_NATIVE_APP) {
    try {
      // Dynamic import keeps the web bundle free of Capacitor plugin code.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { Browser } = (await import("@capacitor/browser")) as any;
      await Browser.open({ url });
    } catch {
      window.open(url, "_blank", "noopener,noreferrer");
    }
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
